'use strict';

angular.module('amexReconciliationApp')
  .directive('datePattern', function () {
      return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModelCtrl) {

          scope.$watch(attrs.ngModel, function (value) {
            var flag = false;
            if (!value || value === undefined || value === 'undefined') {
              flag = true;
            }
            ngModelCtrl.$setValidity('datePattern', !flag);
          });
        }
      };
    }
  );



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/datePattern.js
// module id = 521
// module chunks = 0